<template>
  <v-dialog
    v-model="editDialog"
    width="900px">
    <div class="dialog-container">
      <div class="dialog-header">
        <h3>Edit Account</h3>
      </div>
      <div class="dialog-body">
        <div class="form-card">
          <div class="form-left">
            <account-form
              ref="base-info"
              :edit="true"
              :formDataLock="formDataLock"
              :form="formData"
              @getFormData="getSubFormData"
            />
          </div>
          <div class="form-right">
            <address-form
              ref="address-info"
              :formDataLock="formDataLock"
              :form="formData"
              :edit="true"
              @getFormData="getSubFormData" />
            <div>
              <span class="title">Password</span>
              <v-button
                type="primary"
                plain
                @click="handlerPassword">Send Password Reset Link to {{formData.identity === 1 ? 'SMS' : 'Email'}}</v-button>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <v-button @click="editDialog = false">Cancel</v-button>
        <v-button
          type="primary"
          @click="handlerSave">Save</v-button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import MixinOptions from '@/mixins/options'
import AccountForm from './form/account-form'
import AddressForm from '@/views/components/address-form'
import { editAccount, sendPasswordRestList } from '@/api/account'
export default {
  name: 'editAccount',
  components: {
    AccountForm,
    AddressForm
  },
  mixins: [MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      editDialog: false,
      formData: {},
      editForm: {},
      subForm: {
        'base-info': false,
        'address-info': false
      },
      formDataLock: 0, // 表單鎖，防止外層修改數據覆蓋了組件裏的表單數據
    }
  },
  computed: {
    address() {
      const arr = [
        this.formData.addr_room,
        this.formData.addr_floor,
        this.formData.addr_block,
        this.formData.addr_building,
        this.formData.addr_street,
        this.getAreaName('district', this.formData.addr_district),
        this.getAreaName('area', this.formData.addr_area),
        this.getAreaName('region', this.formData.addr_region)
      ]
      return arr.filter(item => item).join(', ')
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler(val) {
        this.formData = JSON.parse(JSON.stringify(val))
      }
    }
  },
  methods: {
    changeDialog(){
      this.editDialog = !this.editDialog
    },
    getSubFormData(form, data) {
      this.subForm[form] = true
      this.editForm = Object.assign(this.editForm, data)
    },
    handlerEdit() {
      this.formDataLock += 1
      this.editForm = JSON.parse(JSON.stringify(this.formData))
      this.editDialog = true
    },
    handlerSave() {
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitForm(key)
      })
      if (Object.values(this.subForm).some(item => item === false)) {
        return
      }
      this.network().editAccount()
    },
    handlerPassword (id){
      this.network().sendPasswordRestList()
    },
    network() {
      return {
        editAccount: async () => {
          this.editForm.id = this.formData.customer_id
          Object.keys(this.editForm).some(key => {
            if( this.editForm[key] =='')
              this.editForm[key] =null
          })
          const { data } = await editAccount(this.editForm)

          this.$message({
            type: 'success',
            message: 'Success'
          })
          this.editDialog = false
          this.formData = Object.assign(this.formData, this.editForm)
        },
        sendPasswordRestList: async () => {
          const { data,status } = await sendPasswordRestList({customer_id:this.form.id})
          //data.message/data.message_lang
          if (status == 200)
          {
            this.$message({
              type: 'success',
              message: 'Success'
            })
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
//.customer-profile {
//  width: 250px;
  .title {
    display: inline-block;
    margin-bottom: 10px;
    font-weight: bold;
    font-size: 14px;
  }
  .label {
    display: inline-block;
    margin: 10px 0;
    font-size: 14px;
    color: #616266;
    font-weight: 500;
  }
  //   .el-button {
  //     margin-top: 20px;
  //   }
  ul {
    margin-bottom: 20px;
    li {
      display: flex;
      padding: 5px;
      list-style: none;
      color: #606266;
      font-size: 12px;
      line-height: 14px;
      border-bottom: 1px solid #dddfe7;
      &:nth-child(2n) {
        background: rgba(0, 0, 0, 0.02);
      }
      span {
        flex: 1;
      }
      span:first-child {
        font-weight: bold;
      }
    }
  }
  .form-card {
    display: flex;
    background: white;
    border-radius: 4px;
    // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .form-left,
    .form-right {
      flex: 1;
    }
    .form-left {
      padding: 20px;
      border-right: 1px solid #dddfe7;
    }
    .form-right {
      padding: 20px;
    }
    .form-block {
      margin-bottom: 15px;
      & > span:first-child {
        display: block;
        padding-bottom: 5px;
        color: #616266;
        font-weight: bold;
        font-size: 14px;
      }
    }
    .title {
      display: block;
      padding-bottom: 15px;
      color: #616266;
      font-size: 20px;
      font-weight: 500;
    }
    .form-flex {
      display: flex;
      justify-content: space-between;
      & > .form-block {
        margin-right: 15px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .dialog-container {
    .dialog-header {
      padding: 15px 15px 0;
    }
    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
    }
  }
//}
</style>